
export const getListCheck = state => state.checks;
export const runCheck = state => state.runChecks;
export const getLoading = state => state.loading;



// WEBPACK FOOTER //
// ./src/redux/list/selectors.js